import React from "react";
import { BackgroundPositionEditor, CustomColorPicker, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertySubTitle, PropertyTitle, escapeUnit } from "../../../common/ui-props/common";
import { ICardListProps } from "../../../common/components/card-list/CardList";
import { IUIPropertyDefinition, IWDDesignModeProps, PropertyPath, findAvailableFields } from "../../../common/common";
import { hasValue } from "../../../../util";
import { WidgetDesignerPillInput } from "../../../common/pill-input/PillInput";
import jp from 'jsonpath'
import { DataSourcePropertyEditor } from "../../../common/ui-props/DataSourceProperty";
import { Input, Select } from "uxp/components";
import { IDataSource } from "../../../common/data-source-picker/datasource";
import { MarginProperty } from "../../../common/ui-props/MarginProperty";
import ActionEditorLink from "../../../common/action-editor/ActionEditor";

export function CardListProperty(props: ICardListProps, datasourcesPath: PropertyPath, title?: string): IUIPropertyDefinition<ICardListProps> {

    return {
        defaults: props,
        render: (props, uxpContext, contextData, containerId, customProps) => {
            let _props = props.uiProps

            const datasources = customProps?.datasources || []


            return <PropertyContainer>
                <PropertyContainerTitle> {hasValue(title) ? title : 'Card List'} </PropertyContainerTitle>
                <PropertyGroup>
                    <PropertyGroupTitle>Card List</PropertyGroupTitle>

                    <Property>
                        <PropertyTitle>Card Type</PropertyTitle>
                        <Select
                            selected={_props.type}
                            onChange={s => {
                                jp.apply(_props, '$.type', () => (s))
                                props.onChange(_props)
                            }}
                            options={[
                                { label: 'Type 01', value: 'card-1' },
                                { label: 'Type 02', value: 'card-2' },
                                { label: 'Type 03', value: 'card-3' },
                            ]}
                            className="widget-designer-input"
                            showEndOfContent
                        />
                    </Property>

                    <Property>
                        <DataSourcePropertyEditor
                            binding={_props.binding}
                            context={props.uxpContext}
                            className={'wd-chart-source'}
                            onChange={(binding) => {
                                // props.onChange(Object.assign({}, _props, { binding }))
                                jp.apply(_props, '$.binding', () => (binding))
                                props.onChange(_props)
                            }}
                            onChangeAny={(p, v) => {

                                props.onChangeAny(datasourcesPath, v);
                            }}
                            sources={datasources}
                            target={'dictionary-array'}
                            title='Data Source'
                            contextData={contextData}
                            designer={props.designer}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Height of the card</PropertyTitle>
                        <PropertySubTitle>Percentage of the height of the mobile</PropertySubTitle>
                        <Input
                            type='number'
                            value={_props.height}
                            onChange={s => {
                                let num = Number(s) || 0
                                if (num < 8) s = '8'
                                else if (num > 200) s = '200'
                                jp.apply(_props, '$.height', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            inputAttr={{
                                max: '200',
                                min: '8'
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Top Margin</PropertyTitle>
                        <Input
                            type='number'
                            value={escapeUnit(_props.marginTop || '', 'px')}
                            onChange={s => {
                                let num = Number(s) || 0
                                if (num < 0) s = '0'
                                else if (num > 200) s = '200'
                                jp.apply(_props, '$.marginTop', () => (s + 'px'))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            inputAttr={{
                                max: '200',
                                min: '0'
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Bottom Margin</PropertyTitle>
                        <Input
                            type='number'
                            value={escapeUnit(_props.marginBottom || '', 'px')}
                            onChange={s => {
                                let num = Number(s) || 0
                                if (num < 0) s = '0'
                                else if (num > 200) s = '200'
                                jp.apply(_props, '$.marginBottom', () => (s + 'px'))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            inputAttr={{
                                max: '200',
                                min: '0'
                            }}
                        />
                    </Property>

                </PropertyGroup>

                <PropertyGroup>
                    <PropertyGroupTitle>Image</PropertyGroupTitle>
                    <Property>
                        <PropertyTitle>Image Field</PropertyTitle>
                        <WidgetDesignerPillInput
                            contextData={props.contextData}
                            value={_props.imageField}
                            onChange={s => {
                                jp.apply(_props, '$.imageField', () => (s))
                                props.onChange(_props)
                            }}
                            className={'widget-designer-pill-input'}
                            placeholder={"Profile image"}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Image Position</PropertyTitle>
                        <BackgroundPositionEditor
                            position={_props?.imagePosition || ''}
                            onChange={s => {
                                jp.apply(_props, '$.imagePosition', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Image Size</PropertyTitle>
                        <Select
                            selected={_props.imageSize || 'cover'}
                            options={[
                                { label: 'Original Size', value: 'auto' },
                                { label: 'Fill Area', value: 'cover' },
                                { label: 'Fit Into Area', value: 'contain' }
                            ]}
                            onChange={s => {
                                jp.apply(_props, '$.imageSize', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Aspect Ratio of the Image</PropertyTitle>
                        <Input
                            value={_props.aspectRatio}
                            onChange={s => {
                                jp.apply(_props, '$.aspectRatio', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                </PropertyGroup>
                <PropertyGroup>
                    <PropertyGroupTitle>Titles</PropertyGroupTitle>

                    {_props.type === 'card-2' &&
                        <Property>
                            <PropertyTitle> Title Section Background Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.bgColor}
                                onChange={s => {
                                    jp.apply(_props, '$.bgColor', () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                    }

                    <Property>
                        <PropertyTitle>Title Field</PropertyTitle>
                        <WidgetDesignerPillInput
                            contextData={props.contextData}
                            value={_props.titleField}
                            onChange={s => {
                                jp.apply(_props, '$.titleField', () => (s))
                                props.onChange(_props)
                            }}
                            className={'widget-designer-pill-input'}
                            placeholder={"Profile image"}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Title Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props.titleColor}
                            onChange={s => {
                                jp.apply(_props, '$.titleColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Title Size</PropertyTitle>
                        <Input
                            type='number'
                            value={escapeUnit(_props.titleSize || '', 'px')}
                            onChange={s => {
                                let num = Number(s) || 0
                                if (num < 8) s = '8'
                                else if (num > 200) s = '200'
                                jp.apply(_props, '$.titleSize', () => (s + 'px'))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            inputAttr={{
                                max: '200',
                                min: '8'
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Sub title Field</PropertyTitle>
                        <WidgetDesignerPillInput
                            contextData={props.contextData}
                            value={_props.subTitleField}
                            onChange={s => {
                                jp.apply(_props, '$.subTitleField', () => (s))
                                props.onChange(_props)
                            }}
                            className={'widget-designer-pill-input'}
                            placeholder={"Profile image"}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Sub Title Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props.subTitleColor}
                            onChange={s => {
                                jp.apply(_props, '$.subTitleColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Sub Title Size</PropertyTitle>
                        <Input
                            type='number'
                            value={escapeUnit(_props.subTitleSize || '', 'px')}
                            onChange={s => {
                                let num = Number(s) || 0
                                if (num < 8) s = '8'
                                else if (num > 200) s = '200'
                                jp.apply(_props, '$.subTitleSize', () => (s + 'px'))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            inputAttr={{
                                max: '200',
                                min: '8'
                            }}
                        />
                    </Property>
                    {_props.type == 'card-1' || _props.type == 'card-2' &&
                        <Property>
                            <PropertyTitle>On click sub title</PropertyTitle>

                            <ActionEditorLink
                                uiProps={props.parentUIProps}
                                designer={props.designer}
                                uxpContext={uxpContext}
                                action={_props.onClick}
                                onChange={s => {
                                    jp.apply(_props, '$.onClick', () => (s))
                                    props.onChange(_props)
                                }}
                                contextData={contextData}
                            />
                        </Property>
                    }

                </PropertyGroup>
                {
                    _props.type == 'card-3' &&
                    <PropertyGroup>
                        <PropertyGroupTitle>Button</PropertyGroupTitle>

                        <>
                            <Property>
                                <PropertyTitle>Button Label</PropertyTitle>
                                <Input
                                    value={_props.buttonLabel}
                                    onChange={s => {
                                        jp.apply(_props, '$.buttonLabel', () => (s))
                                        props.onChange(_props)
                                    }}
                                    className="widget-designer-input"
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Button Background Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.buttonBG}
                                    onChange={s => {
                                        jp.apply(_props, '$.buttonBG', () => (s))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Button Label Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.buttonLabelColor}
                                    onChange={s => {
                                        jp.apply(_props, '$.buttonLabelColor', () => (s))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>On click button </PropertyTitle>

                                <ActionEditorLink
                                    uiProps={props.parentUIProps}
                                    designer={props.designer}
                                    uxpContext={uxpContext}
                                    action={_props.onClick}
                                    onChange={s => {
                                        jp.apply(_props, '$.onClick', () => (s))
                                        props.onChange(_props)
                                    }}
                                    contextData={contextData}
                                />
                            </Property>
                        </>
                    </PropertyGroup>
                }

            </PropertyContainer>
        }
    }
}
